import { render, staticRenderFns } from "./orderQueryHistory.vue?vue&type=template&id=73d4d820&"
import script from "./orderQueryHistory.vue?vue&type=script&lang=js&"
export * from "./orderQueryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports